import getSingleData from './use-cases/getSingleData.js'
import triggerAction from './use-cases/triggerAction.js'

class DataController {
  static async getSingleData(dataKey, filters, networkRepo) {
    return getSingleData(dataKey, filters, networkRepo)
  }

  static async triggerAction(dataKey, data, networkRepo, method = 'post') {
    return triggerAction(dataKey, data, networkRepo, method)
  }
}

export default DataController
